import styles from './ogsMain.module.css'
import { useNavigate } from "react-router-dom";
import TeamCard from '../../../components/TeamCard/TeamCard';
import { ogs_betreuung, schulministeriumNRW } from '../../../../config/references_files';
function OGSMain() {
    const navigate = useNavigate();
    const abteilungen = [
        {
            team: "Am Sonnenhügel / Eudenbach",
            img: "/images/ogs/sonnenhuegel_eudenbach_kombiniert_vertical.png",
            altText: "Bild: Grundschule Sonnenhügel + Eudenbach",
            link: "/ogs/am-sonnenhuegel",
        },
        {
            team: "Kule Kiste",
            liga: "13:00 Betreuung",
            img: "/images/OGS/kulekiste_small.jpg",
            alt: "Bild: Eingang Kule Kiste",
            link: "/ogs/kule-kiste",
        },
        {
            team: "Gymnasium am Oelberg",
            img: "/images/OGS/gymnasium_small.jpg",
            alt: "Bild: Gymnasium am Oelberg",
            link: "/ogs/oelberg-gymnasium",
        }
    ]
    return (

        <section className={styles.content}>
            <h1 className={styles.title}>Offene Ganztagsschule</h1>
            <div className={styles.options}>
                {abteilungen.map((item, index) => (
                    <TeamCard key={index} item={item} />
                ))}
            </div>
            <section id='kontakt' className={styles.kontaktSection}>
                <h2>Kontaktmöglichkeiten</h2>
                <div className={styles.kontakte}>
                    <div className={styles.kontakt}>
                        <p>OGS:</p>
                        <ul>
                            <li><span className={styles.label}>Tel.:</span>02244 / 87 78 520</li>
                            <li>
                                <span className={styles.label}>E-Mail:</span>
                                <a href="mailto:ogs@tus05-oberpleis.de" className={styles.email}>
                                    ogs@tus05-oberpleis.de
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.kontakt}>
                        <p>Kule Kiste:</p>
                        <ul>
                            <li><span className={styles.label}>Tel.:</span>02244 / 87 78 520</li>
                            <li>
                                <span className={styles.label}>E-Mail:</span>
                                <a href="mailto:kulekiste@tus05-oberpleis.de" className={styles.email}>
                                    kulekiste@tus05-oberpleis.de
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.kontakt}>
                        <p>OGS Eudenbach:</p>
                        <ul>
                            <li><span className={styles.label}>Tel.:</span>02244 / 91 89 054</li>
                            <li>
                                <span className={styles.label}>E-Mail:</span>
                                <a href="mailto:ogs-eudenbach@tus05-oberpleis.de" className={styles.email}>
                                    ogs-eudenbach@tus05-oberpleis.de
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.kontakt}>
                        <p>Geschäftsstelle TuS 05 Oberpleis e.V.:</p>
                        <ul>
                            <li><span className={styles.label}>Tel.:</span>02244 / 90 20 117</li>
                            <li>
                                <span className={styles.label}>E-Mail:</span>
                                <a href="mailto:geschaeftsstelle@tus05-oberpleis.de" className={styles.email}>
                                    geschaeftsstelle@tus05-oberpleis.de
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.kontakt}>
                        <p>Nachmittagsbetreuung Gymnasium am Oelberg:</p>
                        <ul>
                            <li><span className={styles.label}>Tel.:</span>0160 / 94 93 82 31</li>
                            <li>
                                <span className={styles.label}>E-Mail:</span>
                                <a href="mailto:imwistoff@tus05-oberpleis.de" className={styles.email}>
                                    imwistoff@tus05-oberpleis.de
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <section className={styles.betreuungsvertrag}>
                <h2>Betreuungsvertrag</h2>
                <p>Den Betreuungsvertrag können Sie <a className={styles.link} href={ogs_betreuung} target="_blank" rel="noopener noreferrer">hier</a> finden.<br />Um ein Kind anzumelden, folgen Sie bitten den <span tabIndex={0} className={styles.link} onClick={() => navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {

                            e.preventDefault(); // Prevent space from scrolling
                            navigate("/ogs/anmeldung-und-elternbeitraege#anmeldung")
                        }
                    }}
                >hier</span> angegebenen Schritten.</p>
            </section>
            <section className={styles.traeger}>
                <h2>Träger</h2>
                <p>Wir, der <span className={styles.textHighlight}>TuS 05 Oberpleis</span> sind seit 2006 Träger</p>
                <ul><li>der OGS Oberpleis,</li><li>der OGS Eudenbach und</li><li>der 13:00 Uhr Betreuung „Kule Kiste".</li></ul>
                <p>Neben dem sportlichen Angebot sehen wir uns in einer gesellschaftlichen Verantwortung für Oberpleis, das Siebengebirge und natürlich auch zusammen mit den anderen Sportvereinen im ganzen Stadtgebiet Königswinter. Natürlich besteht ein großer Teil dieser Verantwortung darin, Kindern und Jugendlichen Sinn und Spaß an Spiel und Bewegung zu vermitteln sowie eine gute pädagogische Betreuung in der Offenen Ganztagsschule zu gewährleisten. </p>
                <p>Das Engagement des TuS im Rahmen der Offenen Ganztagesschule (OGS) ist in der Region sicherlich einzig und wir empfinden es als etwas sehr Besonderes, dass über 30 Mitarbeitende des TuS fast 300 Kinder an den Standorten Oberpleis und Eudenbach pädagogisch betreuen und begleiten dürfen.
                </p>
                <p>„Bewegung, Spiel und Sport sind unverzichtbare Bestandteile einer ganzheitlichen Persönlichkeitsentwicklung von Kindern und Jugendlichen. Sportvereine bieten mit ihren Angeboten sowohl Bewegungsmöglichkeiten als auch die Gelegenheit, individuelle Talente zu entdecken und zu fördern. Die Lernenden entwickeln Fairplay und Teamgeist, die Bereitschaft zu Partizipation und zur Übernahme von Verantwortung. Die Zusammenarbeit mit Sportvereinen trägt zu einer bewegungsfreudigen, gesundheitsorientierten und von gegenseitigem Respekt geprägten Schulkultur bei.“
                    Quelle: <a className={styles.link} href={schulministeriumNRW} target="_blank" rel="noopener noreferrer">Schulministerium NRW</a>
                </p>
            </section>
        </section>
    )
}

export default OGSMain;